<template>
  <DashboardWidget
    canGoFullscreen
    title="Conto Economico"
    class="conto-economico-sankey-widget no-overflow"
    dialog-class="modal--type-dashboard-widget modal--type-dashboard-widget-sankey"
  >
    <v-chart :options="chart" :autoresize="true" />
    <template #fullscreen>
      <v-chart :options="chartFull" :autoresize="true" />
    </template>
  </DashboardWidget>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/sankey';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/tooltip';

export default {
  name: 'dashboard-widget-conto-economico-sankey',
  components: {
    DashboardWidget: () => import('./DashboardWidget'),
    'v-chart': ECharts,
  },
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chart () {
      return {
        series: [
          {
            type: 'sankey',
            layout: 'none',
            focusNodeAdjacency: 'allEdges',
            data: [
              {
                name: 'Ricavi',
                depth: 0,
              },
              {
                name: 'Scorte',
                depth: 0,
              },
              {
                name: 'Credito d\'imposta',
                depth: 1,
              },
              {
                name: 'Gross Margin',
                depth: 1,
              },
              {
                name: 'EBITDA',
                depth: 2,
              },
              {
                name: 'Personale',
                depth: 2,
              },
              {
                name: 'COGS',
                depth: 2,
              },
              {
                name: 'G&A',
                depth: 2,
              },
              {
                name: 'Ammortamenti',
                depth: 3,
              },
              {
                name: 'EBIT',
                depth: 3,
              },
              {
                name: 'EBT',
                depth: 4,
              },
              {
                name: 'Costi Finanziari',
                depth: 4,
              },
              {
                name: 'Tasse',
                depth: 5,
              },
              {
                name: 'Risultato Netto',
                depth: 5,
              },
            ],
            links: [
              {
                source: 'Credito d\'imposta',
                target: 'EBITDA',
                value: this.values.creditoImposta || 0,
              },
              {
                source: 'Ricavi',
                target: 'Gross Margin',
                value: this.values.ricavi || 0,
              },
              {
                source: 'Scorte',
                target: 'Gross Margin',
                value: this.values.deltaScorte || 0,
              },
              {
                source: 'Gross Margin',
                target: 'Personale',
                value: this.values.personale || 0,
              },
              {
                source: 'Gross Margin',
                target: 'COGS',
                value: this.values.cogs || 0,
              },
              {
                source: 'Gross Margin',
                target: 'G&A',
                value: this.values.ga || 0,
              },
              {
                source: 'Gross Margin',
                target: 'EBITDA',
                value: this.values.ebitda || 0,
              },
              {
                source: 'EBITDA',
                target: 'Ammortamenti',
                value: this.values.ammortamenti || 0,
              },
              {
                source: 'EBITDA',
                target: 'EBIT',
                value: this.values.ebit || 0,
              },
              {
                source: 'EBIT',
                target: 'Costi Finanziari',
                value: this.values.costiFinanziari || 0,
              },
              {
                source: 'EBIT',
                target: 'EBT',
                value: this.values.ebt || 0,
              },
              {
                source: 'EBT',
                target: 'Tasse',
                value: this.values.tasse || 0,
              },
              {
                source: 'EBT',
                target: 'Risultato Netto',
                value: this.values.risultato || 0,
              },
            ],
            levels: [
              {
                depth: 0,
                itemStyle: {
                  color: '#fbb4ae',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 1,
                itemStyle: {
                  color: '#b3cde3',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 2,
                itemStyle: {
                  color: '#ccebc5',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 3,
                itemStyle: {
                  color: '#decbe4',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 4,
                itemStyle: {
                  color: '#dd00b5',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
              {
                depth: 5,
                itemStyle: {
                  color: '#0cccb5',
                },
                lineStyle: {
                  color: 'source',
                  opacity: 0.6,
                },
              },
            ],
            lineStyle: {
              curveness: 0.8,
            },
          },
        ],
      };
    },
    chartFull () {
      const chartFull = this.chart;
      chartFull.tooltip = {
        trigger: 'item',
        triggerOn: 'mousemove',
      };

      return chartFull;
    },
  },
};
</script>

<style lang="scss">

.conto-economico-sankey-widget {
  .echarts {
    height: 100%;
  }
}

.modal--type-dashboard-widget-sankey {
  max-width: 80%;
  max-height: 80vh;

  .echarts {
    height: 80vh;
    width: 100%;
  }
}

</style>
